<template>
  <v-container fluid py-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid pt-0>
          <v-row align="center">
            <div>
              <h1 class="headline">Client Titles</h1>
            </div>
            <div>
              <v-tooltip
                v-if="$store.getters.hasAccessTo('clients:create')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-2"
                    fab
                    dark
                    color="primary"
                    @click="onCreateNew"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Client Title</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      :search="search"
      item-key="id"
      class="elevation-1"
      v-bind="pagingOptions"
      fixed-header
      hide-default-footer
      @update:options="onListOptionsUpdate"
    >
      <template v-slot:item.notInUse="{ item }">
        <v-simple-checkbox
          v-model="item.notInUse"
          :disabled="true"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <default-list-actions
          :item="item"
          :hide-view="true"
          :hide-remove="hideRemove"
          :hide-edit="hideEdit"
          @deleteItem="deleteItem"
          @editItem="editItem"
        ></default-list-actions>
      </template>
    </v-data-table>
    <edit-client-title-dialog
      v-model="editedClientTitle"
      :show="showClientTitleEditor"
      @close="showClientTitleEditor = false"
      @input="onSave"
    ></edit-client-title-dialog>
  </v-container>
</template>
<script>
import { ListMixin } from "../../../mixins/ListMixin";
import { ALL_CLIENT_TITLES_SEARCH_QUERY } from "../../../constants/graphql";
import GetMoreResults from "../shared/GetMoreResults";
import DefaultListActions from "../shared/DefaultListActions";
import EditClientTitleDialog from "./EditClientTitleDialog";
import { removeGQLTypename } from "../../../helpers";
import gql from "graphql-tag";

const DELETE_MUTATION = gql`
  mutation deleteClientTitle($id: ID!) {
    deleteClientTitle(id: $id) {
      id
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createClientTitle($input: ClientTitleInput!) {
    createClientTitle(input: $input) {
      id
      title
      notInUse
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateClientTitle($id: ID!, $input: ClientTitleInput!) {
    updateClientTitle(id: $id, input: $input) {
      id
      title
      notInUse
    }
  }
`;

export default {
  name: "ClientTitlesList",
  mixins: [ListMixin],
  components: {
    GetMoreResults,
    DefaultListActions,
    EditClientTitleDialog,
  },

  data() {
    return {
      clientTitles: {},
      editedClientTitle: {},
      showClientTitleEditor: false,
      headers: [
        {
          text: "Title",
          value: "title",
          name: "title",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
          align: "center",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.clientTitles && this.clientTitles.edges
        ? this.clientTitles.edges.map(removeGQLTypename)
        : [];
    },
    hideRemove() {
      return !this.$store.getters.hasAccessTo("clients:delete");
    },
    hideEdit() {
      return !this.$store.getters.hasAccessTo("clients:edit");
    },
  },

  methods: {
    async onSave(payload) {
      this.showClientTitleEditor = false;
      const { id, ...input } = payload;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
        });
        this.$apollo.queries.clientTitles.refetch();
        this.$store.dispatch("showAppSnackbar", {
          msg: "Client Title saved.",
        });
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.editedClientTitle = { ...item };
      this.showClientTitleEditor = true;
    },
    onCreateNew() {
      this.editedClientTitle = { name: "New Client Title" };
      this.showClientTitleEditor = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: item.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Client Title removed." });

      if (this.$apollo.queries.clientTitles != null) {
        this.$apollo.queries.clientTitles.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
      //console.log(err);
    },
  },

  apollo: {
    clientTitles: {
      query: ALL_CLIENT_TITLES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.clientTitles.totalCount;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/clients/ClientTitlesList.vue